export const DEFAULT_OUTCOME_OPTIONS = [
  { value: 'no_action', label: 'No action required' },
  { value: 'verbal_warning', label: 'Verbal warning' },
  { value: 'written_warning', label: 'Written warning' },
  { value: 'training_required', label: 'Training required' },
  { value: 'monitoring', label: 'Increased monitoring' },
  { value: 'suspension', label: 'Suspension' },
  { value: 'termination', label: 'Termination' },
];

export const slugifyOutcome = (label) => {
  const slug = String(label || '')
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return slug || `custom_${Date.now()}`;
};

export const normalizeOutcomeOptions = (options) => {
  const source = Array.isArray(options) && options.length ? options : DEFAULT_OUTCOME_OPTIONS;
  const seen = new Set();
  const out = [];
  source.forEach((opt) => {
    const label = typeof opt === 'string' ? opt : opt?.label;
    const value = typeof opt === 'string' ? slugifyOutcome(opt) : (opt?.value || slugifyOutcome(label));
    if (!label || !value || seen.has(value)) return;
    seen.add(value);
    out.push({ value, label });
  });
  return out.length ? out : DEFAULT_OUTCOME_OPTIONS;
};
